import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { SELECTION_ID } from '../../selection';
import { DataFlowNode } from './dataflow';
export var IdentifierNode =
/*#__PURE__*/
function (_DataFlowNode) {
  _inherits(IdentifierNode, _DataFlowNode);

  _createClass(IdentifierNode, [{
    key: "clone",
    value: function clone() {
      return new IdentifierNode(null);
    }
  }]);

  function IdentifierNode(parent) {
    _classCallCheck(this, IdentifierNode);

    return _possibleConstructorReturn(this, _getPrototypeOf(IdentifierNode).call(this, parent));
  }

  _createClass(IdentifierNode, [{
    key: "producedFields",
    value: function producedFields() {
      return new Set([SELECTION_ID]);
    }
  }, {
    key: "hash",
    value: function hash() {
      return 'Identifier';
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return {
        type: 'identifier',
        as: SELECTION_ID
      };
    }
  }]);

  return IdentifierNode;
}(DataFlowNode);